module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGQAAAADfVVwdAAAA/ElEQVRIDe2SsQ4BQRCG/7mIXqJCq1LR6XgAiUK8hBeQU7vzAl5CFJJ7AFQ6nUqLRqEXMW7IyWG5udPeNrvZ/PN9k9kF0pVO4N8JkBZQGHIPhP49zxgdBjTW1KoERYeHV4YdBloEZ2/TIHxnOkcKTPAApJH8FLzD/bAncAZaWslXgQmeK6Mj4NMWU63EKPgG33TpLILKhLNayYcgCi4CWVrJi0ALfyh0kqcgLlwruQuSwjUSKrhc5SvWQdg3evJbggcN7qN205uQhZoVLkwKF4Y0JI0J440JlFxuMCNfrmO2aNIlHIh7bsw5s12h7YuOO5uWcevTfDqBzwncAM14m6jXjk0vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/pc/icon_top.png
// module id = 637Z
// module chunks = 0